import { FolderableAppType } from 'FoldersApp/enums/folderable-app-type.enum';
export const RISK_PROFILE_FOLDERABLE_LIST_MODAL_APP_CONFIG = {
    appName: 'RiskProfileApp',
    folderableAppType: FolderableAppType.MODAL,
    itemNamePlural: 'Risk Profiles',
};
